import React, { useState, useRef } from 'react';

import './Select.scss';
import bem from '../../utils/bem';
import angleDown from '../../images/angle-down.svg';
import AnimateHeight from '../AnimateHeight';
import useClickOutside from '../../utils/hooks/useClickOutside';

const Select = ({
  options,
  onSelect,
  selected,
  onBlur,
  disabled,
  id,
  name,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const close = () => {
    if (open) {
      onBlur();
    }
    setOpen(false);
  };
  useClickOutside(ref, close);
  return (
    <div className={bem('select', { open })} ref={ref}>
      <ul className="select__options">
        <AnimateHeight height={open ? 'auto' : 0} duration={200}>
          {options?.map(option => (
            <li className="select__option" key={option.value}>
              <button
                className={bem('select__option-button', {
                  selected: selected?.value === option.value,
                })}
                onClick={() => {
                  onSelect(option);
                  setOpen(false);
                }}
                type="button"
              >
                {option.label}
              </button>
            </li>
          ))}
        </AnimateHeight>
      </ul>
      <button
        type="button"
        className="select__toggle-button"
        onClick={() => {
          if (open) {
            onBlur();
          }
          setOpen(!open);
        }}
      >
        <input
          className="select__selected"
          type="text"
          disabled={disabled}
          value={selected?.value || ''}
          readOnly
          id={id}
          name={name}
        />
        <img className="select__angle" src={angleDown} alt="Angle" />
      </button>
    </div>
  );
};
Select.defaultProps = {
  onBlur: () => {},
};

export default Select;
